module.exports = __webpack_public_path__ + "help-a3e73771adf9e1a0be373f4ff02eab97.svg";